<template>
  <v-card id="tax-integracion-compensacion" class="px-4 pt-2 pb-4 my-0 elevation-0">
    <v-card-title class="px-1">
      <h1 class="card-title">
        Integración y compensación de rentas
      </h1>
    </v-card-title>

    <v-card-text class="pt-0 pb-3 px-3">
      <v-row>
        <v-col cols="12" md="12" lg="6" xl="4" class="px-4">
          <TaxTitle
            title="Total ganancias patrimoniales"
            :boxNumber="integracionCompensacion.boxes.gananciasPatrimoniales.number"
            color="secondary"
          />
          <v-simple-table fixed-header class="mt-4">
            <template v-slot:default>
              <tbody>
                <tr
                  :class="{
                    'row-advise':
                      integracionCompensacion.boxes.gananciasPatrimoniales
                        .someIncompleteExchangeRate,
                  }"
                >
                  <td class="items-flex">
                    <span>
                      Total ganancias patrimoniales
                      <InfoIcon
                        :size="15"
                        :text="`Suma de todas las ganancias o pérdidas del cuadro superior. Este campo aparece en el caso de que ese valor sea positivo`"
                      />
                    </span>
                    <template
                      v-if="
                        integracionCompensacion.boxes.gananciasPatrimoniales
                          .someIncompleteExchangeRate
                      "
                    >
                      <div class="ml-3">
                        <WarningIcon
                          :text="$t(`views.tax.integracionCompensacion.patrimoniales.warning`)"
                        />
                      </div>
                    </template>
                  </td>
                  <td class="text-right">
                    <currency
                      v-if="integracionCompensacion.boxes.gananciasPatrimoniales.data"
                      :value="integracionCompensacion.boxes.gananciasPatrimoniales.data"
                      :currency="user.baseCurrency"
                      text-green
                    />
                    <span v-else></span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12" md="12" lg="6" xl="4" class="px-4">
          <TaxTitle
            title="Total pérdidas patrimoniales"
            :boxNumber="integracionCompensacion.boxes.perdidasPatrimoniales.number"
            color="secondary"
          />
          <v-simple-table fixed-header class="mt-4">
            <template v-slot:default>
              <tbody>
                <tr
                  :class="{
                    'row-advise':
                      integracionCompensacion.boxes.perdidasPatrimoniales
                        .someIncompleteExchangeRate,
                  }"
                >
                  <td class="items-flex">
                    <span>
                      Total pérdidas patrimoniales
                      <InfoIcon
                        :size="15"
                        :text="`Suma de todas las ganancias o pérdidas del cuadro superior. Este campo aparece en el caso de que ese valor sea negativo`"
                      />
                    </span>
                    <template
                      v-if="
                        integracionCompensacion.boxes.perdidasPatrimoniales
                          .someIncompleteExchangeRate
                      "
                    >
                      <div class="ml-3">
                        <WarningIcon
                          :text="$t(`views.tax.integracionCompensacion.patrimoniales.warning`)"
                        />
                      </div>
                    </template>
                  </td>
                  <td class="text-right">
                    <currency
                      v-if="integracionCompensacion.boxes.perdidasPatrimoniales.data"
                      :value="integracionCompensacion.boxes.perdidasPatrimoniales.data"
                      :currency="user.baseCurrency"
                      text-red
                      negative
                    />
                    <span v-else></span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12" md="12" lg="6" xl="4" class="px-4">
          <TaxTitle
            title="Total rendimientos capital mobiliario"
            :boxNumber="integracionCompensacion.boxes.rendCapMob.number"
            color="secondary"
          />
          <v-simple-table fixed-header class="mt-4">
            <template v-slot:default>
              <tbody>
                <tr
                  :class="{
                    'row-advise':
                      integracionCompensacion.boxes.rendCapMob.someIncompleteExchangeRate,
                  }"
                >
                  <td class="items-flex">
                    <span>
                      Total rendimientos capital mobiliario
                      <InfoIcon
                        :size="15"
                        :text="`Suma de los ingresos íntegros por dividendos y demás rendimientos y los intereses de cuentas y depósitos`"
                      />
                    </span>
                    <template
                      v-if="integracionCompensacion.boxes.rendCapMob.someIncompleteExchangeRate"
                    >
                      <div class="ml-3">
                        <WarningIcon
                          :text="$t(`views.tax.integracionCompensacion.rendCapMob.warning`)"
                        />
                      </div>
                    </template>
                  </td>
                  <td class="text-right">
                    <currency
                      :value="integracionCompensacion.boxes.rendCapMob.data"
                      :currency="user.baseCurrency"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <!-- <v-col cols="12" md="12" lg="6" xl="4" class="px-4">
          <TaxTitle
            title="Base imponible del ahorro"
            :boxNumber="integracionCompensacion.boxes.baseImponible.number"
            color="secondary"
          />
          <v-simple-table fixed-header class="mt-4">
            <template v-slot:default>
              <tbody>
                <tr
                  :class="{
                    'row-advise':
                      integracionCompensacion.boxes.baseImponible.someIncompleteExchangeRate,
                  }"
                >
                  <td class="items-flex">
                    <span>
                      Base imponible del ahorro
                      <InfoIcon
                        :size="15"
                        :text="`Suma de las ganancias/pérdidas patrimoniales y el total de rendimientos del capital mobiliario`"
                      />
                    </span>
                    <template
                      v-if="integracionCompensacion.boxes.baseImponible.someIncompleteExchangeRate"
                    >
                      <div class="ml-3">
                        <WarningIcon
                          :text="$t(`views.tax.integracionCompensacion.patrimoniales.warning`)"
                        />
                      </div>
                    </template>
                  </td>
                  <td class="text-right">
                    <currency
                      :value="integracionCompensacion.boxes.baseImponible.data"
                      :currency="user.baseCurrency"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col> -->
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import Currency from '@/views/components/common/Currency.vue'
import WarningIcon from '@/views/components/common/WarningIcon.vue'
import InfoIcon from '@/views/components/common/InfoIcon.vue'
import TaxTitle from '@/views/components/tax/taxDocs/renta/TaxTitle'

export default {
  components: { Currency, WarningIcon, InfoIcon, TaxTitle },
  props: {
    integracionCompensacion: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>

<style lang="scss">
#tax-integracion-compensacion {
  .items-flex {
    display: flex;
    align-items: center;
  }
}
</style>
